import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spin } from 'antd';
import { useTranslation } from 'react-i18next';

import modal from '~components/modal';
import { Roles as RolesIcon } from 'common/components/svgs';
import useSwitchRole from '../useSwitchRole';
import RoleItem from '~client/components/switch-role/role-item';

const rolesHashMap = {
  admin: 'role-admin',
  agent_admin: 'agent_admin',
  content_manager: 'role-content-supervisor',
  content_manager_level_2: 'role-content-specialist',
  pms_landlord: 'role-landlord',
  supply: 'role-supply',
  regional_supply_head: 'role-regional-supply-head',
  financial: 'financial',
  bd: 'bd',
  bc: 'bc',
  bd_admin: 'bd-admin',
  regional_bd_head: 'regional-bd-head',
};

const SwitchRolePage = ({ onClose }) => {
  const { t } = useTranslation();

  const { userRoles, currentRole, setCurrentRole, handleConfirmSwitchRole } = useSwitchRole({
    onClose,
  });

  return (
    <div className="switch-role-page">
      <div className="switch-role-page__container">
        <Choose>
          <When condition={!userRoles?.length}>
            <Spin />
          </When>
          <Otherwise>
            <div className="switch-role-page__position-container">
              <RolesIcon className="switch-role-page__icon-roles" />
              <h3 className="switch-role-page__title">
                {t('cms.switch_role_modal.description.switch_role')}
              </h3>
              <div className="switch-role-page__roles-wrapper">
                <For each="role" index="index" of={userRoles}>
                  <RoleItem
                    key={index}
                    t={t}
                    hash={rolesHashMap[role.slug]}
                    role={role}
                    isSelected={currentRole === role.slug}
                    handleSelectRole={() => setCurrentRole(role.slug)}
                  />
                </For>
              </div>
              <Button
                size="large"
                type="primary"
                className="switch-role-page__btn switch-role-page__btn--confirm"
                disabled={currentRole === null}
                onClick={handleConfirmSwitchRole}
              >
                {t('cms.switch_role_page.btn.confirm')}
              </Button>
            </div>
          </Otherwise>
        </Choose>
      </div>
    </div>
  );
};

SwitchRolePage.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default modal()(SwitchRolePage);
